import React, { useState } from 'react';
import { parse, stringify } from 'query-string';
import moment from 'moment-timezone';
import { PayloadStates } from '@lore/utils';
import useStewardshipFilter from '../../projects/useStewardshipFilter';
import REQUIRED_FIELDS_PAST from '../../projects/REQUIRED_FIELDS_PAST';
import { useConnect } from '@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('project.find', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS_PAST.$and,
          completed: true,
          // showInGallery: false,
          galleryStatus: 'Hide',
          $or: stewardshipFilter,
          ...extra
        }
      }
    },
    pagination: {
      page: parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function(model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}
